import { Product } from '~/models/product/Product'

export class ProductsState {
  public products: Product[] = []
}

export default (): ProductsState => new ProductsState()
